import { styled } from '@mui/system';
import { FormControl, Select, MenuItem } from '@mui/material';

const TextStyle = {
  fontFamily: 'Fjalla One',
  fontWeight: '400',
  fontSize: '18px',
  lineHeight: '22px',
};

const TextInputProps = {
  sx: {
    fontFamily: 'Fjalla One',
    fontWeight: '400',
    fontSize: '18px',
    lineHeight: '22px',
    color: '#000',
    '& .MuiInput-input': {
      paddingTop: '0',
    },
  },
};

const TimeZoneCreateBtnContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginTop: '30px',
  },
}));

const TimezoneSelectCreateBtn = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '30px',
  width: '275px',
  border: '1px solid #AA9178',
  borderRadius: '4px',
  marginLeft: 'auto',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    marginLeft: '0',
  },
}));

const TimeZoneFormControl = styled(FormControl)({
  width: '215px',
  '& .MuiOutlinedInput-notchedOutline': {
    border: 0,
  },
  boxShadow: 'none',
  '& .MuiOutlinedInput-input': {
    padding: '4px 0 0 8px',
  },
});

const TimeZoneSelect = styled(Select)({
  '& .MuiSvgIcon-root': {
    color: 'rgba(153, 152, 154, 0.7)',
  },
});

const TimeZoneLabel = styled('p')({
  fontSize: '16px',
  fontWeight: 400,
  color: 'rgba(153, 152, 154, 0.7)',
  fontFamily: 'Fjalla One',
  lineHeight: '20px',
  margin: '0',
});

const CreateBtn = styled('button')({
  color: '#fff',
  fontFamily: 'Fjalla One',
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '20px',
  backgroundColor: '#AA9178',
  border: 'none',
  cursor: 'pointer',
  padding: '0 9px',
  margin: '0',
});

const TimeZoneErrorMessage = styled('div')({
  margin: '0 0 0 auto',
  fontSize: '12px',
  color: 'red',
  textAlign: 'left',
  width: '275px',
  height: '18px',
});

const ErrorMessageEmpty = styled('div')({
  height: '18px',
});

const TimeZoneCreateBtn = ({ formik }) => {
  return (
    <TimeZoneCreateBtnContainer>
      <TimezoneSelectCreateBtn>
        <TimeZoneFormControl>
          <TimeZoneSelect
            id="timeZone"
            name="timeZone"
            displayEmpty
            label={'Your timezone'}
            value={formik.values.timeZone}
            onChange={formik.handleChange}
            inputProps={TextInputProps}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <TimeZoneLabel>Your timezone</TimeZoneLabel>;
              }
              return selected;
            }}
          >
            <MenuItem style={TextStyle} value={'NSW, TAS, VIC, ACT, UTC+10:00'}>
              NSW, TAS, VIC, ACT, UTC+10:00
            </MenuItem>
            <MenuItem style={TextStyle} value={'SA, UTC+10:30'}>
              SA, UTC+10:30
            </MenuItem>
            <MenuItem style={TextStyle} value={'QLD, UTC+10:00'}>
              QLD, UTC+10:00
            </MenuItem>
            <MenuItem style={TextStyle} value={'NT, UTC+09:30'}>
              NT, UTC+09:30
            </MenuItem>
            <MenuItem style={TextStyle} value={'WA, UTC+08:00'}>
              WA, UTC+08:00
            </MenuItem>
          </TimeZoneSelect>
        </TimeZoneFormControl>
        <CreateBtn type="submit">Update</CreateBtn>
      </TimezoneSelectCreateBtn>
      {formik.errors.timeZone && formik.touched.timeZone ? (
        <TimeZoneErrorMessage>please enter your timezone</TimeZoneErrorMessage>
      ) : (
        <ErrorMessageEmpty />
      )}
    </TimeZoneCreateBtnContainer>
  );
};

export default TimeZoneCreateBtn;
